const BASE_PATH = (global as any).basePath || '/';

export const PATH_ENTRY: string = BASE_PATH;
export const PATH_SIGNIN: string = `${BASE_PATH}signin`;
export const PATH_SIGNUP: string = `${BASE_PATH}signup`;



// WEBPACK FOOTER //
// ./src/paths.ts